import { 
  FETCH_VIDEO, 
  CLEAR_VIDEO,
  RETRANSCODE
 } from '../actions'

export default function video(state = {
  isFetching: true,
  shortcode: null
}, action) {
  switch (action.type) {
    case CLEAR_VIDEO:
      return {
        isFetching: false,
        shortcode: null
      }
    case FETCH_VIDEO:
      if (action.error) {
        return {
          isFetching: false,
          shortcode: null
        }
      } 
      return {
        ...state, shortcode: action.payload.shortcode
      }
    case RETRANSCODE:
      return {...state, shortcode: action.payload.shortcode}
    default:
      return state
  }
}
